import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import * as ownActions from '@redux/actions';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CommonsService {

  constructor(private _store: Store<AppState>) { }


  /**
   * -------------------------------------------------------
   * @summary getURlView
   * @description  Toma el nombre de la vista cargada en la url
   * @param {any} event evento capturado
   * @param {any} urlRoute route capturado de la URL
   * -------------------------------------------------------
   */
  getURlView(event: any, urlRoute: any) {
    // console.log(`urlRoute`, urlRoute)
    let arrayUrl1 = urlRoute.split('/');
    let arrayUrl2 = arrayUrl1[1].split('#');
    // console.log(`arrayUrl1`, arrayUrl1.length)
    // console.log(`arrayUrl12`, arrayUrl2.length)
    let urlActiveLevel1 = '';
    let urlActiveLevel2 = '';

    if (arrayUrl2.length === 1) {
      if (arrayUrl2[0] === 'products') {
        urlActiveLevel1 = 'productos';
      } else {
        if (arrayUrl2[0] === '') {
          urlActiveLevel1 = '/home';
        } else {
          urlActiveLevel1 = '/' + arrayUrl2[0];
        }
      }
      this._store.dispatch(
        ownActions.setUrl({ urlActive1: urlActiveLevel1, urlActive2: '' })
      );
    }
    else {
      if (arrayUrl2[1] === 'scrollcontacts') {
        urlActiveLevel1 = 'contacts';
        urlActiveLevel2 = arrayUrl2[1];
      } else {
        urlActiveLevel1 = arrayUrl2[0];
        urlActiveLevel2 = arrayUrl2[1];
      }

      this._store.dispatch(
        ownActions.setUrl({
          urlActive1: urlActiveLevel1,
          urlActive2: urlActiveLevel2,
        })
      );



    }
  }
}
